export default __webpack_public_path__ + "static/step4-e94088081fc04a778dc6c57dfc31c1ca.svg";